import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { IglesiasService } from '../services/iglesias.service';
import { UserStore } from '../services/user-store.service';

/**
 * SCRUM-93: Admin entra siempre. Líder solo si la iglesia tiene gráficos activos.
 * Contador va a /contador. Sin sesión u otro rol, a login.
 * La iglesia suspendida se resuelve en la pantalla, no en el guard.
 */
export const graficosGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const iglesiasService = inject(IglesiasService);

  if (!userStore.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (userStore.isSuper() || userStore.isAdmin()) {
    return true;
  }

  if (userStore.isLider()) {
    return iglesiasService.getCurrentIglesia().pipe(
      map((iglesia) => (iglesia.grafico ? true : router.createUrlTree(['/lider']))),
      catchError(() => of(router.createUrlTree(['/lider']))),
    );
  }

  if (userStore.isContador()) {
    return router.createUrlTree(['/contador']);
  }

  return router.createUrlTree(['/login']);
};
